import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import SubscriptionSection from '../components/SubscriptionSection';
import '../styles/Profile.css';

const Profile = () => {
  const [activeTab, setActiveTab] = useState('intro');

  // Fallback data for projects when backend is unavailable
  const fallbackProjects = [
    {
      id: 1,
      title: 'IOT & CCTV',
      description: 'Hệ thống giám sát và IoT thông minh cho doanh nghiệp',
      image: '/images/IOT-CCTV.jpg',
      category: 'IOT & Security',
      slug: 'iotcctv',
      status: 'completed',
      featured: true,
    },
    {
      id: 2,
      title: 'SOLAR POWER',
      description: 'Hệ thống năng lượng mặt trời cho gia đình và doanh nghiệp',
      image: '/images/SOLAPOWER.jpg',
      category: 'Renewable Energy',
      slug: 'solar',
      status: 'completed',
      featured: true,
    },
    {
      id: 3,
      title: 'ARCHITECTURAL & CONSTRUCTION',
      description: 'Thiết kế và thi công các công trình hiện đại',
      image: '/images/CONTRUCTION.jpg',
      category: 'Construction',
      slug: 'architecturalconstruction',
      status: 'completed',
      featured: true,
    },
    {
      id: 4,
      title: 'INTERIOR & GARDEN',
      description: 'Thiết kế nội thất và sân vườn thông minh',
      image: '/images/INTERIOR&GADEN.jpg',
      category: 'Interior Design',
      slug: 'landscapegarden',
      status: 'completed',
      featured: true,
    }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'intro':
        return (
          <div className="profile-intro-content">
            <p className="profile-greeting">
              Kính gửi Quý đối tác, Quý khách hàng!
            </p>
            
            <p className="profile-text">
              Trong một thế giới vận hành bởi tốc độ và tính tức thời, nhiều doanh nghiệp chọn thích nghi bằng cách thu gọn mục tiêu và đơn giản hóa tư duy. Nhưng Phúc An Solutions không sinh ra để thích nghi. Chúng tôi ra đời để kiến tạo.
            </p>
            
            <p className="profile-text">
              Không phải chỉ kiến tạo một lĩnh vực hay chuỗi dịch vụ, mà là kiến tạo một tư duy hoàn toàn mới về "giải pháp" – nơi công nghệ, thiết kế, không gian sống và tư duy vận hành không bị chia cắt, mà hợp nhất thành một hệ thống đủ mạnh để thay đổi cách người ta xây dựng, sử dụng và cảm nhận về nơi mình tồn tại.
            </p>
            
            <p className="profile-text">
              Chúng tôi khởi nguồn từ một nhánh công nghệ, nhưng chưa bao giờ chọn đứng yên trong giới hạn. Dựa trên nền tảng Công nghệ thông tin và Giải pháp an ninh – vốn được xem là phần "kỹ thuật lạnh" – Phúc An đã từng bước mở rộng phạm vi hoạt động, hợp nhất các mảnh ghép tưởng chừng rời rạc thành một tổng thể: Công nghệ thông tin, CCTV, kiến trúc, nội thất, xây dựng và năng lượng.
            </p>
            
            <p className="profile-text">
              Không phân ngành, không đóng khung – mà kết nối, mở rộng và tái thiết. Mọi lĩnh vực đều quy tụ trong một hệ giá trị chung: nghiên cứu và cung cấp các giải pháp tối ưu chi phí, tối đa công năng, phù hợp nhất với nhu cầu thực tiễn của từng khách hàng.
            </p>
            
            <p className="profile-text">
              Điều đó không khiến mọi thứ dễ hơn. Ngược lại, nó đòi hỏi chúng tôi phải giữ những tiêu chuẩn khắt khe – không chỉ trong kỹ thuật, mà cả trong tư duy, con người và cam kết trách nhiệm. Chúng tôi không phục vụ thị trường bằng các tài liệu tiếp thị bóng bẩy, mà đồng hành cùng khách hàng bằng những cuộc đối thoại mang tính phản biện – xoay quanh chiến lược, hiệu quả dài hạn và thẩm mỹ ứng dụng.
            </p>
            
            <p className="profile-text">
              Chúng tôi hiểu rằng làm đúng chưa đủ. Làm đẹp cũng chưa đủ. Mà phải làm ra những thứ đúng – đẹp – bền – linh hoạt – có thể thích ứng với tương lai. Đó không chỉ là kỹ năng, mà là một năng lực tổng hợp: tư duy hệ thống, khả năng nhìn xa, lòng tử tế trong từng chi tiết.
            </p>
            
            <p className="profile-text">
              Chúng tôi không gọi mình là nhà cung cấp dịch vụ. Chúng tôi là những người theo đuổi tư duy liên kết – kết nối con người với không gian, dữ liệu với vận hành, cảm xúc với hiệu suất, hiện tại với tương lai.
            </p>
            
            <p className="profile-text">
              Mỗi công trình, mỗi hệ thống là một lần tái định nghĩa "quy chuẩn" và "giới hạn". Không gian sống, hệ thống vận hành, nguồn năng lượng – mọi thứ đều xứng đáng được kiến tạo bằng tư duy lớn và trái tim đủ lửa.
            </p>
            
            <p className="profile-text">
              Chúng tôi không bán giải pháp.<br/>
              Chúng tôi trao đi những hệ thống thông minh – bền vững – mang đậm dấu ấn con người.
            </p>
            
            <p className="profile-text">
              Mỗi thành công của Phúc An Solutions là nhờ sự tin tưởng và đồng hành từ Quý đối tác, Quý khách hàng.
            </p>
            
            <p className="profile-signature">
              "GIẢI PHÁP TIÊN TIẾN, KIẾN TẠO TƯƠNG LAI"
            </p>
            
            <p className="profile-company">
              CÔNG TY TNHH PHÚC AN SOLUTIONS
            </p>

            {/* Sơ đồ tổ chức */}
            <div className="profile-document-section">
              <h2 className="profile-document-title">Sơ Đồ Tổ Chức</h2>
              <div className="profile-document-container">
                <img
                  src="/images/SODOCTY.png"
                  alt="Sơ đồ tổ chức công ty"
                  className="profile-document-image"
                />
              </div>
            </div>

            {/* Giấy phép kinh doanh */}
            <div className="profile-document-section">
              <h2 className="profile-document-title">Giấy Phép Kinh Doanh</h2>
              <div className="profile-document-container">
                <img
                  src="/images/GIẤY PHÉP KINH DOANH PAS - Da Che.webp"
                  alt="Giấy phép kinh doanh"
                  className="profile-document-image"
                />
              </div>
            </div>
          </div>
        );

      case 'services':
        return (
          <div className="profile-services-content">
            {/* Block 1: CCTV & IOT */}
            <div className="service-block">
              <div className="service-image-container">
                <img 
                  src="/images/cam.jpg" 
                  alt="Giải pháp CCTV & IOT" 
                  className="service-image"
                />
              </div>
              <div className="service-info">
                <h3 className="service-title">Giải pháp CCTV & IOT</h3>
                <p className="service-description">
                  Phúc An Solutions cung cấp giải pháp thiết bị an ninh, giám sát, điều khiển thông minh cho doanh nghiệp, nhà xưởng, hộ gia đình. Đảm bảo an toàn, bảo mật và tối ưu vận hành với công nghệ hiện đại nhất.
                </p>
                <ul className="service-features">
                  <li>• Bán, lắp đặt camera, thiết bị an ninh chuyên nghiệp</li>
                  <li>• Giải pháp nhà thông minh, IoT toàn diện</li>
                  <li>• Kiểm soát ra vào, báo động, báo cháy tự động</li>
                  <li>• Hệ thống giám sát từ xa qua smartphone</li>
                </ul>
              </div>
            </div>

            {/* Block 2: PC & Workstation */}
            <div className="service-block service-block-reverse">
              <div className="service-image-container">
                <img 
                  src="/images/pc.jpg" 
                  alt="PC & Workstation" 
                  className="service-image"
                />
              </div>
              <div className="service-info">
                <h3 className="service-title">Buôn bán, kinh doanh thiết bị điện, điện máy, thiết bị IT, PC, Workstation</h3>
                <p className="service-description">
                  Cung cấp các loại máy tính, thiết bị văn phòng, thiết bị điện tử, linh kiện chính hãng cho doanh nghiệp, trường học, hộ gia đình. Đảm bảo chất lượng cao và giá cả cạnh tranh.
                </p>
                <ul className="service-features">
                  <li>• Máy tính để bàn, laptop, workstation cao cấp</li>
                  <li>• Thiết bị văn phòng: máy in, máy photocopy, máy chiếu</li>
                  <li>• Linh kiện máy tính: CPU, RAM, ổ cứng, card đồ họa</li>
                  <li>• Thiết bị mạng: router, switch, access point</li>
                </ul>
              </div>
            </div>

            {/* Block 3: Interior Design */}
            <div className="service-block">
              <div className="service-image-container">
                <img 
                  src="/images/xay2.jpg" 
                  alt="Tư vấn, thiết kế, thi công nội thất" 
                  className="service-image"
                />
              </div>
              <div className="service-info">
                <h3 className="service-title">Tư vấn, thiết kế, thi công nội thất</h3>
                <p className="service-description">
                  Thiết kế, thi công nội thất nhà ở, văn phòng, showroom, không gian thương mại hiện đại, tối ưu công năng và thẩm mĩ. Mang đến không gian sống và làm việc hoàn hảo.
                </p>
                <ul className="service-features">
                  <li>• Thiết kế nội thất nhà ở, biệt thự cao cấp</li>
                  <li>• Nội thất văn phòng, showroom, cửa hàng</li>
                  <li>• Thi công hoàn thiện từ A-Z</li>
                  <li>• Tư vấn phong thủy và tối ưu không gian</li>
                </ul>
              </div>
            </div>

            {/* Block 4: Construction */}
            <div className="service-block service-block-reverse">
              <div className="service-image-container">
                <img 
                  src="/images/xay.jpg" 
                  alt="Tư vấn, thiết kế, thi công xây dựng trọn gói" 
                  className="service-image"
                />
              </div>
              <div className="service-info">
                <h3 className="service-title">Tư vấn, thiết kế, thi công xây dựng trọn gói</h3>
                <p className="service-description">
                  Thiết kế, thi công nhà xưởng, nhà phố, công trình dân dụng, công nghiệp với giải pháp tối ưu, tiết kiệm chi phí và đảm bảo chất lượng. Dịch vụ trọn gói từ thiết kế đến bàn giao.
                </p>
                <ul className="service-features">
                  <li>• Thiết kế kiến trúc và kết cấu chuyên nghiệp</li>
                  <li>• Thi công nhà xưởng, nhà phố, biệt thự</li>
                  <li>• Xây dựng công trình công nghiệp</li>
                  <li>• Quản lý dự án và giám sát chất lượng</li>
                </ul>
              </div>
            </div>

            {/* Block 5: Solar Power */}
            <div className="service-block">
              <div className="service-image-container">
                <img 
                  src="/images/mt.webp" 
                  alt="Tư vấn, giải pháp, lắp đặt hệ thống điện & năng lượng mặt trời" 
                  className="service-image"
                />
              </div>
              <div className="service-info">
                <h3 className="service-title">Tư vấn, giải pháp, lắp đặt hệ thống điện & năng lượng mặt trời</h3>
                <p className="service-description">
                  Tư vấn, thiết kế và thi công hệ thống điện, năng lượng mặt trời cho doanh nghiệp, nhà ở, giúp tiết kiệm chi phí và bảo vệ môi trường. Giải pháp năng lượng xanh bền vững.
                </p>
                <ul className="service-features">
                  <li>• Hệ thống điện mặt trời hòa lưới và độc lập</li>
                  <li>• Tư vấn công suất phù hợp với nhu cầu</li>
                  <li>• Lắp đặt và bảo trì định kỳ</li>
                  <li>• Hỗ trợ thủ tục pháp lý và hưởng ưu đãi</li>
                </ul>
              </div>
            </div>

            {/* Block 6: Content & Media */}
            <div className="service-block service-block-reverse">
              <div className="service-image-container">
                <img 
                  src="/images/contennt.png" 
                  alt="Quảng cáo, xây dựng & chăm sóc hình ảnh, truyền thông số" 
                  className="service-image"
                />
              </div>
              <div className="service-info">
                <h3 className="service-title">Quảng cáo, xây dựng & chăm sóc hình ảnh, truyền thông số</h3>
                <p className="service-description">
                  Phúc An Solutions cung cấp dịch vụ quảng cáo, xây dựng thương hiệu, chăm sóc hình ảnh, truyền thông số, sản xuất nội dung số chuyên nghiệp. Giúp doanh nghiệp tiếp cận khách hàng hiệu quả.
                </p>
                <ul className="service-features">
                  <li>• Thiết kế logo, nhận diện thương hiệu</li>
                  <li>• Quản lý fanpage, website, mạng xã hội</li>
                  <li>• Sản xuất nội dung marketing sáng tạo</li>
                  <li>• Tạo chiến lược truyền thông số bài bản</li>
                </ul>
              </div>
            </div>

            {/* Block 7: Media Production */}
            <div className="service-block">
              <div className="service-image-container">
                <img 
                  src="/images/quay.webp" 
                  alt="Quay chụp sự kiện, dựng phim, quảng cáo video thực tế" 
                  className="service-image"
                />
              </div>
              <div className="service-info">
                <h3 className="service-title">Quay chụp sự kiện, dựng phim, quảng cáo video thực tế</h3>
                <p className="service-description">
                  Phúc An Solutions nhận quay chụp sự kiện, dựng phim, quảng cáo video thực tế, sử dụng thiết bị hiện đại, đội ngũ sáng tạo, mang đến sản phẩm ấn tượng, chất lượng cao.
                </p>
                <ul className="service-features">
                  <li>• Quay phim sự kiện, hội nghị, lễ kỷ niệm</li>
                  <li>• Sản xuất video quảng cáo, TVC chuyên nghiệp</li>
                  <li>• Chụp ảnh sản phẩm, portrait, sự kiện</li>
                  <li>• Dựng phim, chỉnh sửa video chất lượng cao</li>
                </ul>
              </div>
            </div>
          </div>
        );

      case 'projects':
        return (
          <div className="profile-projects-content">
            <div className="projects-intro">
              <p>
              Mỗi công trình không đơn thuần là sản phẩm hoàn thiện mà là nơi chúng tôi gửi gắm tư duy sáng tạo, tinh thần trách nhiệm và sự chỉnh chu trong từng chi tiết – để từ đó tạo nên sự khác biệt và dấu ấn bền vững.
              </p>
            </div>
              
            <div className="projects-grid">
              {fallbackProjects.slice(0, 4).map((project) => (
                <Link 
                  key={project.id} 
                  to={`/projects/${project.slug}`}
                  className="project-card"
                >
                  <div className="project-card-image">
                    <img 
                      src={project.image} 
                      alt={project.title} 
                      className="project-image"
                    />
                    {project.status === 'completed' && (
                      <div className="project-status">
                        <span className="project-status-badge">
                          Hoàn thành
                        </span>
                      </div>
                    )}
                  </div>
                  <div className="project-card-content">
                    <h3 className="project-title">
                      {project.title}
                    </h3>
                    {project.description && (
                      <p className="project-description">
                        {project.description}
                      </p>
                    )}
                  </div>
                </Link>
              ))}
            </div>
            
            
          </div>
        );

      case 'why-choose':
        return (
          <div className="profile-whyus-content">
            <h2 className="whyus-title">Vì sao khách hàng tin chọn Phúc An Solutions?</h2>
            <div className="whyus-grid">
              {/* 1. Chất lượng vượt trội */}
              <div className="whyus-item">
                <div className="whyus-icon">
                  <img 
                    src="/images/21.png" 
                    alt="Chất lượng vượt trội" 
                    className="whyus-icon-image"
                  />
                </div>
                <h3 className="whyus-item-title">Chất lượng vượt trội</h3>
                <p className="whyus-item-text">Chúng tôi cam kết 100% sản phẩm chính hãng, bền bỉ, an toàn và hiệu suất cao. Không ngừng đổi mới và cải tiến, Phúc An Solutions luôn mang đến những giải pháp đạt chuẩn chất lượng khắt khe nhất.</p>
              </div>
              
              {/* 2. Giải pháp tiết kiệm, tối ưu chi phí */}
              <div className="whyus-item">
                <div className="whyus-icon">
                  <img 
                    src="/images/20.png" 
                    alt="Giải pháp tiết kiệm, tối ưu chi phí" 
                    className="whyus-icon-image"
                  />
                </div>
                <h3 className="whyus-item-title">Giải pháp tiết kiệm, tối ưu chi phí</h3>
                <p className="whyus-item-text">Chúng tôi luôn lắng nghe nhu cầu của bạn và tư vấn giải pháp phù hợp nhất, giúp tối ưu ngân sách mà vẫn đảm bảo hiệu quả sử dụng vượt trội.</p>
              </div>
              
              {/* 3. Tốc độ thi công nhanh chóng */}
              <div className="whyus-item">
                <div className="whyus-icon">
                  <img 
                    src="/images/22.png" 
                    alt="Tốc độ thi công nhanh chóng" 
                    className="whyus-icon-image"
                  />
                </div>
                <h3 className="whyus-item-title">Tốc độ thi công nhanh chóng</h3>
                <p className="whyus-item-text">Quy trình làm việc chuyên nghiệp, đội ngũ kỹ thuật viên lành nghề giúp rút ngắn thời gian thi công, đảm bảo hoàn thành đúng tiến độ với chất lượng cao nhất.</p>
              </div>
              
              {/* 4. Bảo hành dài hạn, hỗ trợ chu đáo */}
              <div className="whyus-item">
                <div className="whyus-icon">
                  <img 
                    src="/images/23.png" 
                    alt="Bảo hành dài hạn, hỗ trợ chu đáo" 
                    className="whyus-icon-image"
                  />
                </div>
                <h3 className="whyus-item-title">Bảo hành dài hạn, hỗ trợ chu đáo</h3>
                <p className="whyus-item-text">Chúng tôi không chỉ cung cấp sản phẩm mà còn cam kết đồng hành dài lâu, với chính sách bảo hành và hỗ trợ tận tình, dịch vụ linh hoạt đáp ứng mọi vấn đề bạn cần.</p>
              </div>
              
              {/* 5. Dịch vụ tận tâm, chuyên nghiệp */}
              <div className="whyus-item">
                <div className="whyus-icon">
                  <img 
                    src="/images/24.png" 
                    alt="Dịch vụ tận tâm, chuyên nghiệp" 
                    className="whyus-icon-image"
                  />
                </div>
                <h3 className="whyus-item-title">Dịch vụ tận tâm, chuyên nghiệp</h3>
                <p className="whyus-item-text">Đội ngũ kỹ thuật viên giàu kinh nghiệm, hỗ trợ khéo léo, tận tình, phục vụ tận nơi theo nhu cầu cụ thể.</p>
              </div>
              
              {/* 6. Lấy khách hàng làm trung tâm */}
              <div className="whyus-item">
                <div className="whyus-icon">
                  <img 
                    src="/images/25.png" 
                    alt="Lấy khách hàng làm trung tâm" 
                    className="whyus-icon-image"
                  />
                </div>
                <h3 className="whyus-item-title">Lấy khách hàng làm trung tâm</h3>
                <p className="whyus-item-text">Mọi giải pháp tại Phúc An Solutions đều hướng đến lợi ích và trải nghiệm của khách hàng. Sự hài lòng của bạn chính là thành công lớn nhất của chúng tôi.</p>
              </div>
            </div>
          </div>
        );

      default:
        return null;
    }
  };
  
  return (
    <main className="profile-main">
      {/* Hero Banner */}
      <div className="profile-hero-banner">
        <img
          src="/images/1023.png"
          alt="Security Camera"
          className="profile-hero-image"
        />
      </div>
      
      {/* Profile Content */}
      <section className="profile-section">
        <div className="profile-container">
          <h1 className="profile-main-title">PROFILE</h1>
          
          <div className="profile-description">
            <p>
              Phúc An Solutions cung cấp giải pháp hiện đại, đồng bộ và tối ưu cho từng mô hình doanh 
              nghiệp. Chúng tôi không chỉ lắp đặt - mà còn thiết kế hệ thống thông minh, bảo mật cao và 
              dễ dàng mở rộng theo nhu cầu phát triển
            </p>
          </div>
          
          {/* Navigation Links */}
          <div className="profile-nav">
            <div className="profile-nav-container">
              <button 
                onClick={() => setActiveTab('intro')}
                className={`profile-nav-button ${activeTab === 'intro' ? 'active' : ''}`}
              >
                GIỚI THIỆU
              </button>
              <button 
                onClick={() => setActiveTab('services')}
                className={`profile-nav-button ${activeTab === 'services' ? 'active' : ''}`}
              >
                DỊCH VỤ
              </button>
              <button 
                onClick={() => setActiveTab('projects')}
                className={`profile-nav-button ${activeTab === 'projects' ? 'active' : ''}`}
              >
                DỰ ÁN TIÊU BIỂU
              </button>
              <button 
                onClick={() => setActiveTab('why-choose')}
                className={`profile-nav-button ${activeTab === 'why-choose' ? 'active' : ''}`}
              >
                VÌ SAO CHỌN CHÚNG TÔI
              </button>
            </div>
          </div>
          
          {/* Tab Content */}
          <div className="profile-tab-content">
            {renderTabContent()}
          </div>
        </div>
      </section>
      
      {/* Subscription Section */}
      <SubscriptionSection />
    </main>
  );
};

export default Profile; 